<template>
<div class="chapter">
<div class="inner_page">
<p class="C829"><strong><span id="page_vii">Contents </span></strong></p>
<p class="P34"><a href="#/html/06_List_of#page_ix">List of Tables and Figures </a></p>
<p class="P35"><a href="#/html/07_Preface#page_xi">Preface </a></p>
<p class="P35"><a href="#/html/08_Acknowle#page_xvii">Acknowledgments </a></p>
<p class="P35"><a href="#/html/09_Introduc#page_1">Introduction: Welcome to Venice </a></p>
<p class="P35"><a href="#/html/10_CHAPTER#page_19">CHAPTER 1. A Beach Town in Transition </a></p>
<p class="P35"><span href="#/html/11_CHAPTER#page_44" title="Link target outside of Sample">CHAPTER 2. The Transformation of a Black Neighborhood </span></p>
<p class="P35"><span href="#/html/12_CHAPTER#page_86" title="Link target outside of Sample">CHAPTER 3. People out of Place </span></p>
<p class="P35"><span href="#/html/13_CHAPTER#page_124" title="Link target outside of Sample">CHAPTER 4. Scenic Neighborhood </span></p>
<p class="P35"><span href="#/html/14_CHAPTER#page_164" title="Link target outside of Sample">CHAPTER 5. Bohemian Theme Park </span></p>
<p class="P35"><span href="#/html/15_CHAPTER#page_204" title="Link target outside of Sample">CHAPTER 6. Fashionable Bohemia </span></p>
<p class="P35"><span href="#/html/16_CHAPTER#page_235" title="Link target outside of Sample">CHAPTER 7. The Future of the American City </span></p>
<p class="P35"><span href="#/html/17_Notes#page_251" title="Link target outside of Sample">Notes </span></p>
<p class="P35"><span href="#/html/18_Bibliogr#page_283" title="Link target outside of Sample">Bibliography </span></p>
<p class="P35"><span href="#/html/19_Index#page_301" title="Link target outside of Sample">Index </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?a9116dc6